// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AskGetabstractAnswerStatus } from "../schema";

export function serialize_AskGetabstractAnswerStatus_internal(value: AskGetabstractAnswerStatus): unknown {
  return ((value: "PROCESSING" | "FINISHED" | "NO_DOCS_FROM_VECTOR_DB" | "NO_DOCS_AFTER_FILTER" | "NO_REFERENCE_IN_ANSWER" | "GENERAL_ERROR" | "TIMEOUT"): unknown => {
    return value;
  })(value);
}
export function serialize_AskGetabstractAnswerStatus(obj: AskGetabstractAnswerStatus): string {
  return renderJsonWithNumbersAsBigint(serialize_AskGetabstractAnswerStatus_internal(obj));
}
export function deserialize_AskGetabstractAnswerStatus_internal(value: unknown): ParserResult<AskGetabstractAnswerStatus> {
  return ((value: unknown): ParserResult<"PROCESSING" | "FINISHED" | "NO_DOCS_FROM_VECTOR_DB" | "NO_DOCS_AFTER_FILTER" | "NO_REFERENCE_IN_ANSWER" | "GENERAL_ERROR" | "TIMEOUT"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/AskGetabstractAnswerStatus]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "PROCESSING":
        return { success: true, value: "PROCESSING" };
      case "FINISHED":
        return { success: true, value: "FINISHED" };
      case "NO_DOCS_FROM_VECTOR_DB":
        return { success: true, value: "NO_DOCS_FROM_VECTOR_DB" };
      case "NO_DOCS_AFTER_FILTER":
        return { success: true, value: "NO_DOCS_AFTER_FILTER" };
      case "NO_REFERENCE_IN_ANSWER":
        return { success: true, value: "NO_REFERENCE_IN_ANSWER" };
      case "GENERAL_ERROR":
        return { success: true, value: "GENERAL_ERROR" };
      case "TIMEOUT":
        return { success: true, value: "TIMEOUT" };
      default:
        return {
          success: false,
          reason: `[#/components/schemas/AskGetabstractAnswerStatus]: '${value}' expected to be enum, one of 'PROCESSING, FINISHED, NO_DOCS_FROM_VECTOR_DB, NO_DOCS_AFTER_FILTER, NO_REFERENCE_IN_ANSWER, GENERAL_ERROR, TIMEOUT'.`,
        };
    }
  })(value);
}
export function deserialize_AskGetabstractAnswerStatus(str: string): ParserResult<AskGetabstractAnswerStatus> {
  return deserialize_AskGetabstractAnswerStatus_internal(parseJsonWithNumbersAsBigint(str));
}
